/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
// export const urls = "http://test.api.51xiaoping.com/evaluate"
// export const uplUrl = "http://39.106.230.221:9002/evaluate"

export const uplUrl = "https://api.51xiaoping.com/evaluate";
export const urls = "https://api.51xiaoping.com/evaluate";
import { POST, BASE_URL } from "../api/index";
// 字典
export function dictCode(params) {
  return POST(urls + "/dict/code", params, "get", "");
}
// 获取可报名学校
export function getListBy(params) {
  return POST(urls + "/school/get-list-by-appCode", params, "get", "");
}

export function upload(params) {
  return POST(uplUrl + "/file/oss-upload", params, "post", "", "");
}
// 查询学生户口信息
export function selectResidence(params) {
  return POST(
    urls + "/enrollment/selectEnrollmentResidence",
    params,
    "get",
    ""
  );
}
// 根据学校ID查询该校下所有的符合报名的小区
export function selectBySchool(params) {
  return POST(urls + "/enrollment/selectBySchoolId", params, "get", "");
}
// 保存学生报名信息
export function saveEnrollmentStudent(params) {
  return POST(
    urls + "/enrollment/saveEnrollmentStudent",
    params,
    "post",
    "",
    ""
  );
}
// 根据学校ID查询学校基础配置信息
export function getSchoolConfig(params) {
  return POST(
    urls + "/enrollment/getSchoolConfigBySchoolId",
    params,
    "get",
    ""
  );
}
// 根据身份证号查询已填写信息
export function getStudentByIdcard(params) {
  return POST(
    urls + "/enrollment/getEnrollmentStudentByIdcard",
    params,
    "get",
    ""
  );
}
// 登录接口
export function validEnrollmentStudent(params) {
  return POST(urls + "/enrollment/validEnrollmentStudent", params, "get", "");
}
// 学生信息查询
export function getInfoByIdCard(params) {
  return POST(urls + "/student/getInfoByIdCard", params, "get", "");
}
// 编辑学生信息
export function getEnrollmentStudent(params) {
  return POST(urls + "/enrollment/getEnrollmentStudentById", params, "get", "");
}
// 获取学校的动态表单
export function getDynamicForm(params) {
  return POST(urls + "/enrollment/getDynamicForm", params, "get", "");
}
// 获取学校信息
export function schoolInfo(params) {
  return POST(urls + "/school/get-info", params, "get", "");
}



// WEBPACK FOOTER //
// ./src/api/home.js